import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Edit = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <path
            fillRule="evenodd"
            d="m29.28 4.587.001-.002a2 2 0 0 1 2.829.001l7.304 7.308a2 2 0 0 1 0 2.828L18.732 35.414a2 2 0 0 1-1.415.586H10a2 2 0 0 1-2-2v-7.28a2 2 0 0 1 .585-1.414L29.28 4.586ZM12 27.547 30.696 8.83l4.476 4.478L16.49 32H12v-4.452ZM42 44H6a2 2 0 1 1 0-4h36a2 2 0 1 1 0 4Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
